import * as React from 'react';
import {Route} from 'react-router-dom';
import Registration from 'pages/Registration/Registration';

export default [
    <Route key="registrationRoute" exact path="/registration" component={Registration} noLayout
    />
];
